import { inkSpacingTokens } from '@ds/tokens';
import styled from '@emotion/styled';

const HeaderIconContainer = styled.div`
    margin: 0 0 ${inkSpacingTokens.spacingM};
    height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;

    svg {
        color: #76748e;
    }
`;

export default HeaderIconContainer;
